import { MARKETER_PRODUCT_TYPE, PROJECTS_PRODUCT_TYPE } from "constants/products";
import DefaultProps from "./default-props";
import { componentStyles } from "./product-cards-grid-mobile-component.scss";
import ProductCardGridMobileComponent from "./product-card-grid-component/product-card-grid-mobile-component";

const ProductCardsGridMobileComponent = (props) => {
  return (
    <div className="product-cards-grid-mobile-component">
      {props?.cards
        ?.filter((card) => card.productType !== MARKETER_PRODUCT_TYPE && card.productType !== PROJECTS_PRODUCT_TYPE)
        .map((card, index) => (
          <ProductCardGridMobileComponent {...card} index={index} />
        ))}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

ProductCardsGridMobileComponent.defaultProps = DefaultProps;

export default ProductCardsGridMobileComponent;
